import { useState } from "react";
import "./FaqContent.css";
import faqData from "./FaqData.json";
import { data } from "./FaqTopicsData.jsx";

const mailId = "ATCI.SONG.IgNite";
const domain = "accenture.com";

function FaqContent() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [search, setSearch] = useState("");

  const filteredFaqs = faqData.filter((item) =>
    item.question.toLowerCase().includes(search.toLowerCase())
  );
  return (
    <>
      <div className="few-pages-banner-wrap">
        <img
          src={process.env.PUBLIC_URL + "/Assets/AllBanners/faq-banner-latest.png"}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="few-pages-banner-box">
          <div className="few-pages-banner-content">
            <h1 className="banner-main-head">Frequently Asked Questions</h1>
            <p className="banner-sub-text">
              Have Questions? We're Here to Help.
            </p>
          </div>
        </div>
      </div>
      {/* first section */}
      <div className="how-help-container">
        <div className="how-help-wrap">
          <h2 className="section-headings">How can we help?</h2>
          <p className="section-sub-text">
            These FAQs cover common questions about how Ignite works, how
            learning is organized, and how progress is tracked.
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="faq-search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      {/* second section */}
      <div className="faq-topic-section">
        <div className="faq-topic-wrap">
          {/* <div className="faq-topic-row row1">
            <div className="faq-topic-box">
              <div className="faq-topic-box">
                //{data.sections.map((section, index) => (
                  <div className={section.className} key={index}>
                    <h3>{section.title}</h3>
                    <ul>
                      {section.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
          <div className="faq-topic-row row2">
            <div className="faq-topic-box">
              <h3>Frequently Asked Questions</h3>
              <div className="faq-container">
                {filteredFaqs.map((item, index) => (
                  <div
                    key={item.id}
                    className={`faq-item ${
                      activeIndex === index ? "active" : ""
                    }`}
                  >
                    <div
                      className="faq-question"
                      onClick={() =>
                        setActiveIndex(activeIndex === index ? null : index)
                      }
                    >
                      {item.question}
                      <span className="icon">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            (activeIndex === index
                              ? "/Assets/FAQ/up-arrow.png"
                              : "/Assets/FAQ/down-arrow.png")
                          }
                          alt="arrow"
                          className="faq-dropdown"
                        />
                      </span>
                    </div>

                    {activeIndex === index && (
                      <div
                        className="faq-answer"
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      ></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* third section */}
      <div className="still-ques-section">
        <div className="still-ques-wrap">
          <div className="still-ques-row">
            {/* <h4>RECOMMENDED</h4> */}
            <h3>Looking for something else?</h3>
            <p>
              If your question isn’t covered here, feel free to reach out to the
              Ignite team. We’ll respond within two working days.
            </p>
            <p className="submit-req-link">
              <a href="mailto:ATCI.SONG.IgNite;">Write to Us</a>
            </p>
            <img
              src={process.env.PUBLIC_URL + "/Assets/FAQ/question-icon.png"}
              alt="question-icon"
              className="question-icon"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default FaqContent;
